<template>
  <div>
    <p v-if="appointmentTitle" class="notification_label">You were assigned to {{ appointmentTitle }} appointment</p>
    <p v-else class="notification_label">You were assigned to an appointment</p>
    <button-link @click="goToLead">{{ notification.data.record_address }}</button-link>
  </div>
</template>

<script>
import router from "../../../router";
import api from "../../../api";
import dates from "../../../services/dates";

/**
 * NOTE: The if statement above is added because the forwarder_label was just added to data in Jan 2023,
 * and we need to support notifications that don't have it yet.
 */
export default {
  name: "AssignedToAppointmentNotification",
  props: {
    notification: Object
  },
  computed: {
    appointmentTitle() {
      if (this.notification.data.hasOwnProperty('appointment_title')) {
        return this.notification.data.appointment_title
      }
      return null
    }
  },
  methods: {
    goToLead() {
      api.notifications.markRead({ notification_id: this.notification.id }).then(() => {
        // NOTE: The database read_at will be different from now, but read_at just needs a date
        // in order for this to work. We don't show the read at time.
        this.notification.read_at = dates.getNowISO()
      });
      router.replace({query: {lead: this.notification.data.record_id}});
    }
  },
}
</script>

<style lang="scss" scoped>
.notification_label {
  margin-bottom: 2px;
  font-size: 0.875rem;
}
</style>
